<template>
  <div>
    <titleFrom
      mode="edit"
      :isLoading="isLoading"
      :item="item"
      @cancel="cancel"
      :permissions="permissions"
      @submit="save"
    />
  </div>
</template>

<script>
import titleFrom from "./../from/titleFrom";
export default {
  name: "edit-option",
  components: {
    titleFrom,
  },
  inject: ["titleRepository"],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async save(payload) {
      this.isLoading = true;
      try {
        let id = this.item.id;
        const response = await this.titleRepository.edit(id, payload);
        this.$notify.success(response.data.message);
        // this.cancel()
        this.$emit("getItems");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style></style>
